module.exports = __webpack_public_path__ + "img/36.27eec6cb.webp";